import { userByIdOptions } from "@/api/queryApi";
import { useStorage } from "@/hooks/contextHooks";
import { useQuery } from "@tanstack/react-query";
import { Spinner, UserAvatar } from "frontend-components";

export default function Pfp({ userId }: { userId: number }) {
    const { url } = useStorage();
    const { data: user, isPending } = useQuery(userByIdOptions({ id: userId }));

    return user ? (
        user.picture ? (
            <img src={`${url}/${user.picture}`} className="rounded-full" />
        ) : (
            <UserAvatar
                className="size-full"
                userId={user.id}
                firstName={user.firstName}
                lastName={user.lastName}
            />
        )
    ) : (
        <div className="w-full h-full flex justify-center">
            <div className="h-full flex flex-col justify-center">{isPending && <Spinner />}</div>
        </div>
    );
}
